import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ApiService } from '../../../../../services/api.service';
import { FileUploadComponent } from '../../../../../common/file-upload/file-upload.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AnagraficaRubrica, ConfigurazioneAccreditamenti, Evento } from '../../../../../shared/interface';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';

@Component({
  selector: 'app-add-subappalto-accrediti-backoffice',
  templateUrl: './add-subappalto-accrediti-backoffice.component.html',
  styleUrls: ['./add-subappalto-accrediti-backoffice.component.css']
})
export class AddSubappaltoAccreditiBackofficeComponent implements OnInit {

  constructor(
    private apiService: ApiService,    
  ) {}

  @ViewChild('uploadVisuraCamerale', { static: false }) uploadVisuraCamerale!: FileUploadComponent;
  @ViewChild('uploadPos', { static: false }) uploadPos!: FileUploadComponent;

  @Input() visible: boolean = false;
  @Input() evento?: Evento;
  
  @Output() close = new EventEmitter<boolean>();  
  
  formSubappalto!: FormGroup;
  configurazione?: ConfigurazioneAccreditamenti;
  rubrica: AnagraficaRubrica[] = [];
  rubricaSel: AnagraficaRubrica | null = null;
  rubricaVisura = '';
  rubricaPos = '';

  attivitaOptions: { attivita: string }[] = [
    { attivita: 'Montaggio' },
    { attivita: 'Smontaggio' },
    { attivita: 'Fornitura impianti' },
    { attivita: 'Noleggio attrezzature' },
    { attivita: 'Audio' },
    { attivita: 'Luci' },
    { attivita: 'Video' },
    { attivita: 'Trasporto' },
    { attivita: 'Allestimento' },
  ];
  attivita_filtrate: { attivita: string }[] = [];

  ngOnInit(): void {
    // Documenti mai obbligatori in BO: li completa poi la compagnia
    this.formSubappalto = new FormGroup({
      ragione_sociale: new FormControl(null, Validators.required),
      piva: new FormControl(null, Validators.required),
      attivita: new FormControl(null, Validators.required),      
      responsabilita: new FormControl(null, Validators.required),
      visura_camerale: new FormControl(null),
      pos: new FormControl(null),
    });

    this.apiService.getConfigurazioneAccreditamenti().subscribe({
      next: (c) => this.configurazione = c,
      error: () => {},
    });

    this.apiService.getRubrica().subscribe({
      next: (list) => {
        this.rubrica = (list || [])
          .slice()
          .sort((a, b) => (a.ragione_sociale || '').localeCompare(b.ragione_sociale || '', 'it'));
      },
      error: () => { this.rubrica = []; },
    });
  }

  onFilterAttivita(event: AutoCompleteCompleteEvent) {
    const filtered = [...this.attivitaOptions].filter(
      (a) => a.attivita.toLowerCase().indexOf(event.query.toLowerCase()) == 0,
    );
    this.attivita_filtrate = filtered.length <= 0 ? [{ attivita: event.query }] : filtered;
  }

  onRubrica(sel: AnagraficaRubrica | null) {
    this.rubricaSel = sel;
    if (!sel) {
      this.rubricaVisura = '';
      this.rubricaPos = '';
      return;
    }
    this.formSubappalto.patchValue({
      ragione_sociale: sel.ragione_sociale || '',
      piva: sel.piva || '',
    });
    this.rubricaVisura = (sel.visura_camerale || '').toString().trim();
    this.rubricaPos = (sel.pos || sel.dvr || '').toString().trim();
  }

  private flag(v: unknown): boolean {
    return v === true || v === 1 || v === '1';
  }

  get visuraObbl(): boolean {
    const e = this.evento as any;
    if (e?.obbl_visura_subappalti != null) return this.flag(e.obbl_visura_subappalti);
    return !!e?.obbligatorieta;
  }

  get posObbligatorio(): boolean {
    const e = this.evento as any;
    if (e?.obbl_pos_subappalti != null) return this.flag(e.obbl_pos_subappalti);
    return !!e?.obbligatorieta;
  }

  onClose() {
    this.visible = false;    
    this.close.emit(this.visible);
  }

  onDocumento(documento: string) {
    this.apiService.openProtectedFile(documento);
  }

  onAdd() {

    let subappalto = new FormData();
    
    subappalto.append("id_evento", (this.evento?.id! || 0).toString());
    subappalto.append('ragione_sociale', this.formSubappalto.get('ragione_sociale')?.value || '');
    subappalto.append('piva', this.formSubappalto.get('piva')?.value || '');
    subappalto.append(
      'attivita',
      (this.formSubappalto.get('attivita')?.value || [])
        .map((a: { attivita: string }) => a.attivita)
        .join(','),
    );
    subappalto.append('visura_camerale', this.formSubappalto.get('visura_camerale')?.value || '');
    subappalto.append('pos', this.formSubappalto.get('pos')?.value || '');
    // Obbligo POS gestito a livello evento (obbl_pos_subappalti), non per singola riga
    subappalto.append('pos_dovuto', this.posObbligatorio ? '1' : '0');
    if (!this.formSubappalto.get('visura_camerale')?.value && this.rubricaVisura) {
      subappalto.append('visura_camerale_ref', this.rubricaVisura);
    }
    if (!this.formSubappalto.get('pos')?.value && this.rubricaPos) {
      subappalto.append('pos_ref', this.rubricaPos);
    }
    
    this.apiService.addSubappalto(subappalto).subscribe({
      next: (data) => {
        this.apiService.setSubappaltiEvento(this.evento?.id!);
        this.apiService.setDocumentiEvento(this.evento?.id!);
      },
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.uploadVisuraCamerale.clearUpload();
        this.uploadPos.clearUpload();

        this.formSubappalto.reset();
        this.rubricaSel = null;
        this.rubricaVisura = '';
        this.rubricaPos = '';
        this.formSubappalto.markAsUntouched();
        this.formSubappalto.markAsPristine();    

        this.onClose()
      }
    });    

  }

}
